import React, {Fragment, useContext} from "react";
import {useAtom} from "jotai";

import FilterContext from "../../Context/FilterContext";

import {applyStateAtom, TAX_MAP} from "../../utils/globals";
import {resetURLParams, resetFastFilters, resetNavFilters} from "../../utils/reset";

const ActiveFilter = ({name, id, taxonomy}) => {
    const {
        activeFilters,
        setActiveFilters,
        setActiveFiltersCounter,
        makeAPICall,
    } = useContext(FilterContext);

    const [applyState, setApplyState] = useAtom(applyStateAtom);

    function removeFilter(payload) {
        const filterID = TAX_MAP[taxonomy];

        const found = activeFilters.some(el => el.id === payload.id);
        if (found) {
            const index = activeFilters.findIndex((obj) => obj.id === payload.id);
            if (index > -1) {
                const slicedFilters = activeFilters.slice();
                slicedFilters.splice(index, 1);
                const splicedFilters = slicedFilters;

                setActiveFilters(splicedFilters);
                setActiveFiltersCounter(splicedFilters.length);
            }
        }

        // remove the id from the applyState[filerID] array
        const filtered = applyState[filterID].filter((value) => value !== payload.id);

        // Update the applyState
        setApplyState({
            ...applyState,
            [filterID]: filtered,
        });

        // Is this the last filter? If so, reset the applyState to the initial state.
        if (filtered.length === 0) {
            resetURLParams();
            resetFastFilters();
            resetNavFilters(setActiveFilters, setActiveFiltersCounter, setApplyState);
        }

        const checkbox = document.querySelector(`.js-filter-checkbox[value='${payload.id}']`)
        if (checkbox.checked) {
            checkbox.click();
        }

        // Call the API.
        makeAPICall();

    }

    return (
        <Fragment>
            <button
                className="active-filter-btn"
                data-filter-taxonomy={taxonomy}
                data-filter-id={id}
                onClick={() => removeFilter({id, name, taxonomy})}
            >
                <span className="btn__copy">{name}</span>
                <span className="btn__icon"><img
                    src="/wp-content/themes/electro/img/svg/icon-close-box-outline.svg"/></span>
            </button>
        </Fragment>
    );
};

export default ActiveFilter;
